module.exports = __webpack_public_path__ + "skinscreening-desktop___Mb8zW.svg";